import { useEffect, useState } from 'react';
import { apiService } from './services/api';
import NotAccessible from './components/NotAccessible';
import NotPublished from './components/NotPublished';
import LoadError from './components/LoadError';
import Loader from './components/Loader';

// "Theme 1", "theme-2", "THEME 3" all resolve to the same loader key.
const normalizeThemeKey = (theme) => String(theme || '').replace(/[^a-z0-9]/gi, '').toLowerCase();

const DEFAULT_THEME_KEY = 'theme1';

const THEME_LOADERS = {
  theme1: () => import('./themes/Theme1/App'),
  theme2: () => import('./themes/Theme2/App'),
  theme3: () => import('./themes/Theme3/App'),
  theme4: () => import('./themes/Theme4/App'),
};

function loadTheme(theme) {
  const loader = THEME_LOADERS[normalizeThemeKey(theme)] || THEME_LOADERS[DEFAULT_THEME_KEY];
  return loader();
}

function App() {
  const [ThemeApp, setThemeApp] = useState(null);
  const [isAccessible, setIsAccessible] = useState(true);
  const [isPublished, setIsPublished] = useState(true);
  const [hasLoadError, setHasLoadError] = useState(false);

  useEffect(() => {

    let isMounted = true;
    const forcedTheme = new URLSearchParams(window.location.search).get('__theme');
    if (forcedTheme) {
      loadTheme(forcedTheme).then((mod) => { if (isMounted) setThemeApp(() => mod.default); });
      return () => { isMounted = false; };
    }
    apiService.getStartPoint()
      .then((data) => {
        apiService.setSiteConfig(data);
        if (data?.website?.request_status !== 'approved') {
          if (isMounted) setIsAccessible(false);
          return null;
        }
        if (!data?.website?.is_published) {
          if (isMounted) setIsPublished(false);
          return null;
        }
        const themeName = data?.theme || "theme1";

        return loadTheme(themeName);
      })
      .catch(() => {
        if (isMounted) setHasLoadError(true);
        return null;
      })
      .then((mod) => { if (isMounted && mod) setThemeApp(() => mod.default); });
    return () => {
      isMounted = false;
    };
  }, []);

  if (!isAccessible) return <NotAccessible />;
  if (!isPublished) return <NotPublished />;
  if (hasLoadError) return <LoadError />;
  if (!ThemeApp) return <Loader />;

  return <ThemeApp />;
}

export default App;
